import { render, staticRenderFns } from "./DisplayImage.vue?vue&type=template&id=15a3931a&scoped=true&lang=pug"
import script from "./DisplayImage.vue?vue&type=script&lang=js"
export * from "./DisplayImage.vue?vue&type=script&lang=js"
import style0 from "./DisplayImage.vue?vue&type=style&index=0&id=15a3931a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a3931a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15a3931a')) {
      api.createRecord('15a3931a', component.options)
    } else {
      api.reload('15a3931a', component.options)
    }
    module.hot.accept("./DisplayImage.vue?vue&type=template&id=15a3931a&scoped=true&lang=pug", function () {
      api.rerender('15a3931a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/DisplayImage.vue"
export default component.exports